import { Typography } from "@mui/material";

import StyledProPage from "features/Auth/Onboarding/ProOnboarding/StyledPage";
import { useAccountReviewCompleteScreen } from "features/Auth/Onboarding/shared/AccountReviewUpsell";

interface Props {
  handleNext: () => void;
  handleBack?: () => void;
  onSkip?: () => void;
  nextLoading?: boolean;
}

const AutopilotOnboardingCompleteScreen = ({
  handleNext,
  handleBack,
  onSkip,
  nextLoading,
}: Props) => {
  const reviewProps = useAccountReviewCompleteScreen({
    defaultTitle: "You're All Set!",
    defaultDescription: (
      <Typography sx={{ fontSize: { xs: 13, md: 18 }, my: 3 }}>
        Bento Autopilot will start finding and pitching brands for you
        automatically. Sit back and let the partnerships come to you.
      </Typography>
    ),
    defaultButtonNext: "Go to Dashboard",
    defaultStepLabel: "Finished",
    handleNext,
    onSkip,
  });

  return (
    <StyledProPage
      stepNumber={7}
      {...reviewProps}
      onBack={handleBack}
      buttonBack="Back"
      splitScreen={false}
      loading={nextLoading}
    />
  );
};
export default AutopilotOnboardingCompleteScreen;
